"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitOptOutDraw = exports.fetchDrawOptOutPreference = exports.fetchOptOutPreferences = exports.optOut = void 0;
var types_1 = require("@pbl/pbl-react-core/lib/models/draws/types");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var lodash_1 = __importDefault(require("lodash"));
var action_type_util_1 = require("../../action-type.util");
var optOut = function (args) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, _a, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 7]);
                dispatch({ type: (0, action_type_util_1.REQUEST)(types_1.OPT_OUT_SUBMIT) });
                if (!!lodash_1.default.isArray(args)) return [3, 2];
                return [4, services_1.DrawsService.submitOptOutPrize(args)];
            case 1:
                _a = _b.sent();
                return [3, 4];
            case 2: return [4, services_1.DrawsService.submitOptOutPrizes(args)];
            case 3:
                _a = _b.sent();
                _b.label = 4;
            case 4:
                payload = _a;
                return [4, dispatch({
                        type: (0, action_type_util_1.SUCCESS)(types_1.OPT_OUT_SUBMIT),
                        payload: payload
                    })];
            case 5:
                _b.sent();
                return [3, 7];
            case 6:
                e_1 = _b.sent();
                dispatch({ type: (0, action_type_util_1.FAILURE)(types_1.OPT_OUT_SUBMIT) });
                return [3, 7];
            case 7: return [2];
        }
    });
}); }; };
exports.optOut = optOut;
var fetchOptOutPreferences = function (prizes) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var entries, drawIds;
    return __generator(this, function (_a) {
        entries = prizes.getEntries();
        if (!entries)
            return [2];
        drawIds = entries
            .filter(function (e) { return !!e.draw && e.draw.playerConfirmationRequired; })
            .map(function (e) { return (!!e.draw ? e.draw.id : 0); });
        if (drawIds && drawIds.length > 0) {
            dispatch({
                type: types_1.OPT_OUT_FETCH_PREFERENCES,
                payload: services_1.DrawsService.fetchOptOutPreferences(drawIds)
            });
        }
        return [2];
    });
}); }; };
exports.fetchOptOutPreferences = fetchOptOutPreferences;
var fetchDrawOptOutPreference = function (drawIds) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: types_1.OPT_OUT_FETCH_PREFERENCES,
            payload: services_1.DrawsService.fetchOptOutPreferences(drawIds)
        }).catch(function () { });
        return [2];
    });
}); }; };
exports.fetchDrawOptOutPreference = fetchDrawOptOutPreference;
var submitOptOutDraw = function (optOutArgs) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, dispatch({
                    type: types_1.OPT_OUT_SUBMIT,
                    payload: services_1.DrawsService.submitOptOutDraw(optOutArgs)
                })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); }; };
exports.submitOptOutDraw = submitOptOutDraw;
//# sourceMappingURL=actions.js.map